module.exports = __webpack_public_path__ + "static/media/weather.7531c725.png";